import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { MuiModal } from 'ui/MuiModal';

interface LocationExportProgressDialogProps {
    open: boolean;
    isInProgress: boolean;
}

export const LocationExportProgressDialog: React.FC<LocationExportProgressDialogProps> = ({
    open,
    isInProgress
}) => (
    <MuiModal open={open} disableBackdropClick={isInProgress} paperMaxWidth={400}>
        <>
            <Typography variant="h5" color="primary" gutterBottom>
                {!isInProgress ? 'Export Complete' : 'Export in Progress'}
            </Typography>

            {isInProgress && (
                <>
                    <Box display="flex" justifyContent="center" my={3}>
                        <CircularProgress />
                    </Box>
                    <Typography variant="body1" color="textSecondary" align="center">
                        Please do not refresh or navigate away from this page
                    </Typography>
                </>
            )}

            {!isInProgress && (
                <Typography variant="body1" color="primary">
                    Export completed successfully! Downloading...
                </Typography>
            )}
        </>
    </MuiModal>
);
